import styles from './form-error.module.css'

export const FormError = ({ text }) => (
  <div className={styles.error}>
    <svg className={styles.icon} height={24} width={24}>
      <use xlinkHref='/icons.svg#icon-info' />
    </svg>
    {text}
  </div>
)
